module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2013-09-22.45a9d93f.md";